import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for the segment library page (partner-scoped)
export const marketingToolingSegmentLibraryAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingViewAccess],
  featureToggles: [FeatureToggle.segmentLibraryEnabled],
  minICPlatformVersion: ICPlatformVersion.r2026_09_0,
  restrictedBannersAllowed: true,
}
